import { Material } from 'src/api/endpoints/materials';
import { baseApi, Group, QueryPayload } from 'src/api';
import { StudentDebt } from 'src/pages/employees/BranchStudentDebtsPage';

export type StudentPerformanceResponse = {
    marks: {
        average: {
            current: number;
            previous: number[];
        };
        last: {
            id: number;
            mark: number;
            date: number;
        }[];
    };
    homework: {
        total: number;
        upcoming: number;
        expired: number;
        completed: number;
        pending: number;
        currentTask: {
            name: string;
            description: string;
            expiryAt: number;
        } | null;
    };
    material: Material | null;
    lesson: {
        time: number;
        theme: string;
    } | null;
};

export type RegisterStudentAccountBody = {
    firstname: string;
    surname: string;
    patronymic: string | null;

    email: string;
    phone: string;
};

const api = baseApi.injectEndpoints({
    endpoints: builder => ({
        getCurrentStudent: builder.query<
            {
                id: number;
                status: any;
                contract: string;
                group: Omit<Group, 'meta' | 'details'> & { launchYear: number };
            },
            void
        >({
            providesTags: [],
            query: (): QueryPayload => ({
                url: '/students/me',
                method: 'GET',
            }),
        }),
        getAccountRegistrationStatus: builder.query<boolean, void>({
            providesTags: ['AccountRegistrationStatus'],
            query: (): QueryPayload => ({
                url: '/students/me/account/registration',
                method: 'GET',
            }),
        }),

        getStudentDebtStatus: builder.query<boolean, void>({
            query: (): QueryPayload => ({
                url: '/students/me/debts/status',
                method: 'GET',
            }),
        }),

        getCurrentStudentDebts: builder.query<StudentDebt[], void>({
            query: (): QueryPayload => ({
                url: '/students/me/debts',
                method: 'GET',
            }),
        }),

        registerAccount: builder.mutation<
            void,
            { body: RegisterStudentAccountBody }
        >({
            invalidatesTags: ['AccountRegistrationStatus'],
            query: ({ body }): QueryPayload => ({
                url: '/students/me/account/registration',
                method: 'POST',
                data: body,
            }),
        }),
        getCurrentStudentPerformance: builder.query<
            StudentPerformanceResponse,
            void
        >({
            providesTags: [],
            query: (): QueryPayload => ({
                url: '/students/me/performance',
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useGetCurrentStudentQuery,
    useGetAccountRegistrationStatusQuery,
    useRegisterAccountMutation,
    useGetCurrentStudentPerformanceQuery,
    useGetStudentDebtStatusQuery,
    useGetCurrentStudentDebtsQuery,
} = api;
